(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function itemsOf(track) {
    return [...track.children].filter(function (el) {
      return el.classList.contains('ssc-row__item') || el.classList.contains('ssc-recent__item');
    });
  }

  function gapOf(track) {
    var style = getComputedStyle(track);
    return parseFloat(style.columnGap || style.gap) || 0;
  }

  function fullCount(track, items) {
    if (!items.length) return 1;
    var width = items[0].getBoundingClientRect().width;
    if (!width) return 1;
    var gap = gapOf(track);
    return Math.max(1, Math.floor((track.clientWidth + gap) / (width + gap)));
  }

  function parkStars(root) {
    (root || document).querySelectorAll('product-card').forEach(function (card) {
      var gallery = card.querySelector('.card-gallery');
      var rating = card.querySelector('.ssc-card-rating');
      if (!gallery || !rating || !rating.querySelector('.ssc-stars')) return;
      if (rating.parentElement !== gallery) gallery.appendChild(rating);
    });
  }

  function init(root) {
    if (!root) return;
    parkStars(root);
    var track = root.matches('.ssc-row__track, .ssc-recent__track')
      ? root
      : root.querySelector('.ssc-row__track, .ssc-recent__track');
    if (!track || track.dataset.sscDots === 'on') return;
    track.dataset.sscDots = 'on';

    var dots = document.createElement('div');
    dots.className = 'ssc-dots';
    dots.hidden = true;
    track.insertAdjacentElement('afterend', dots);

    function pin() {
      if (!track.dataset.sscTouched) track.scrollLeft = 0;
    }
    track.addEventListener('pointerdown', function () {
      track.dataset.sscTouched = '1';
    }, { once: true });
    pin();
    requestAnimationFrame(pin);
    setTimeout(pin, 500);

    function paint() {
      var items = itemsOf(track);
      var count = Math.max(0, items.length - fullCount(track, items) + 1);
      var current = dots.querySelectorAll('button').length;
      if (count <= 1) {
        dots.hidden = true;
        dots.replaceChildren();
        return;
      }
      dots.hidden = false;
      if (current !== count) {
        dots.replaceChildren();
        for (var i = 0; i < count; i++) {
          var button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', 'Go to product ' + (i + 1));
          button.addEventListener('click', (function (index) {
            return function () {
              var row = itemsOf(track);
              var item = row[index];
              if (!item || !row[0]) return;
              track.dataset.sscTouched = '1';
              track.scrollTo({
                left: item.offsetLeft - row[0].offsetLeft,
                behavior: reduce ? 'auto' : 'smooth'
              });
            };
          })(i));
          dots.appendChild(button);
        }
      }
      var step = items[0].getBoundingClientRect().width + gapOf(track);
      var active = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / (step || 1))));
      dots.querySelectorAll('button').forEach(function (button, index) {
        if (index === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    new MutationObserver(paint).observe(track, { childList: true });
    paint();
  }

  function boot() {
    document.querySelectorAll('[data-ssc-row], [data-ssc-recent], .ssc-ymal__rail').forEach(init);
  }

  window.SSCRow = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
